// extracted by mini-css-extract-plugin
export default {"issueItem":"IssueItem_issueItem__YSr29","title":"IssueItem_title__us7QQ","bottom":"IssueItem_bottom__Ivhj3","product":"IssueItem_product__1OyaJ"};